<template lang="pug">
  .documents-list-business.table-view
    .table-view-header
      h3 Documentos
    b-table(:fields="fields" thead-class="bg-light-primary" :items="businesses" @row-clicked="goToBusinessFolders" hover responsive)
      template(v-slot:cell(name)="{value}")
        font-awesome-icon(:icon="['fas', 'folder']")
        span.ml-2(style="cursor:pointer") {{value}}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      fields: [
        { label: 'Nombre', key: 'name', sortable: true},
        { label: 'rut', key: 'rut', sortable: true},
        { label: 'Propietario', key: 'legalRepresentative', sortable: true},
      ]
    }
  },
  methods: {
    ...mapActions(['listActiveBusiness']),
    goToBusinessFolders (business) {
      const businessId = business.id
      this.$router.push({ name: 'BusinessFolders', params: { businessId } })
    }
  },
  computed: {
    ...mapGetters(['businesses'])
  },
  created () {
    this.listActiveBusiness()
  }
}
</script>